import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthlyGivingProgramComponent } from './components/monthly-giving-program/monthly-giving-program.component';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';

@NgModule({
  declarations: [MonthlyGivingProgramComponent],
  imports: [
    CommonModule,
    CloseBtnModule,
    ModuleLoaderModule
  ],
  exports: [MonthlyGivingProgramComponent]
})
export class MonthlyGivingProgramModule { }
